export default class SelectOptionVuetify {
  constructor(value, text) {
    this.value = value
    this.title = text
  }
}
